import React, { useState, useEffect, useRef } from 'react';
import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";
import Partnerships from "./Partnerships";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));


function EducationForAll() {

  const { formatMessage, locale } = useIntl();
  const fm = id => formatMessage({id});

  const partnerships = [
    {
      titleKey: 'FULBRIGHT UNIVERSITY VIETNAM, VIETNAM',
      descriptionKeys: [
        'Fulbright University Vietnam (FUV) mission is to inspire new generations of leaders and ambitious thinkers of origins to become creators of positive change in Vietnam and beyond. As Vietnam\'s first liberal arts university, FUV practice and teach continuous innovation in pursuit of bold, ethical answers to local and global challenges.',
        'Our family is working with FUV on a Changemaker scholarship as well as initiatives promoting mindfulness in education.'
      ],
      logo: 'image 2300 (1).png',
      status: 'ongoing',
      url: 'https://heartandmind.edu.vn/'
    },
    {
      titleKey: 'VIETSEEDS FOUNDATION, VIETNAM',
      descriptionKeys: [
        'VietSeeds is a non-profit organization committed to bringing EQUAL ACCESS to college education for ALL students in Vietnam. VietSeeds invests in highly motivated students from underserved demographics. They empower scholars to have rich intellectual lives, fulfilling careers, not only to become financially independent but also to be engaging citizens so that they can start giving back to society.',
        'Our family collaborates with VietSeeds through our scholarship at FUV as well as supporting their programs.'
      ],
      logo: 'vietseeds 1 (1).png',
      status: 'ongoing',
      url: 'https://teachforall.org/'
    },
    {
      titleKey: 'TEACH FOR VIETNAM, VIETNAM',
      descriptionKeys: [
        'Teach For Viet Nam (TFV) was established in 2016 as a non-profit organization in Vietnam focused on education. It is an independent partner of the global education network Teach For All.',
        'TFV seeks and develops fellows from diverse fields, equipping them with necessary skills in teaching, leadership, and placing them to work for two years in public schools in rural areas nationwide. Our family collaborates on Teach for Vietnam related projects and supporting the team on inner transformation.'
      ],
      logo: 'image 2301.png',
      status: 'ongoing',
      url: 'https://bonnevauxwccm.org/'
    },
    {
      titleKey: 'PACIFIC LINKS FOUNDATION, VIETNAM',
      descriptionKeys: [
        'Pacific Links Foundation breaks the cycle of poverty and trafficking by empowering women and youth through improving life skills, raising self-awareness, bringing new knowledge and opening opportunities and supportive networks.',
        'Our family supports two education projects in 2018-2022: • Scholarship to Elevate Education & Develop Skills • Girls Empowerment Scholarships • Socio-Emotional Learning'
      ],
      logo: 'image 2306.png',
      status: 'completed',
      url: 'https://www.innerleadership.global/'
    },
    {
      titleKey: 'CHOKI TRADITIONAL ART SCHOOL, BHUTAN',
      descriptionKeys: [
        'Located just north of the capital of Bhutan, in the beautiful mountain valley of Kabesa, Choki Traditional Art School is the only private institute that provides free education to underprivileged youths who have a keen interest in learning the traditional arts and crafts. The school focuses on developing solid background and skills of the students so that they can go on to become independent and contribute to preserving Bhutan\'s unique art and culture.'
      ],
      logo: 'image 2307.png',
      status: 'completed',
      url: 'https://jesuitmission.org.au/'
    },
    {
      titleKey: 'THE CHANGE LEADER ACADEMY, SINGAPORE & CHINA',
      descriptionKeys: [
        'The Change Leader Academy aims to free the creativity and innovation of Chinese youth that are authentic to their passions and interests. We run human centered design workshops to middle and high school students to empathize with communities and develop independent ventures that have positive social impact. So far, CLA has completed workshops with over 600 students in 5 schools and with partners such as UN Women and the Global Issues Network (GIN) Conference.'
      ],
      logo: 'Group 3006 (1).png',
      status: 'completed',
      url: 'https://www.zen-azi.org/en'
    },
  ];

  return (
    <>
      <div className='mt-14 md:mt-24 relative'>
        <img className='hidden md:block w-full' src={imgs['Group 3032 (1).png']}/>
        <img className='md:hidden block w-full' src={imgs['Group 3033.png']}/>

        <div
          className='w-[227px] md:w-[600px] text-center absolute text-lg md:text-5xl font-bold text-white z-1 md:leading-[1.2] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          {
            locale === 'en' ? 'Where learning begins, possibility follows.' :
              'Nơi giáo dục mở ra cánh cửa cho các cơ hội.'
          }
        </div>
      </div>

      <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
        <div className='text-center mb-2 md:mb-3'>
          <h2 className='text-sm md:text-xl font-bold uppercase'>
            {fm('Education for all')}
          </h2>
        </div>
        <div className='max-w-[90%] md:max-w-2xl mx-auto'>
          <p className='text-base text-black md:text-2xl leading-relaxed text-center'>
            {fm('Every child carries infinite potential. We support education so that potential is not determined by circumstance, but unlocked through opportunity.')}
          </p>
        </div>
      </div>

      <div className='block md:hidden'>
        <img src={imgs['image 2216 (1).png']} className='w-full'/>
      </div>
      <div className='bg-white py-2 md:py-10 px-8 md:px-[7.5%]'>
        <h2 className='text-xl md:text-3xl font-bold mb-2 md:mb-4 text-black'>
          {fm('Why Education for all?')}
        </h2>
        <div className='flex flex-col md:flex-row gap-8 md:gap-24 items-start'>
          {/* Text Section - Left */}
          <div className='flex-1 md:flex-[2]'>

            <div className='space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed text-black'>
              <p>
                {fm('Education is the foundational building block of every society. We believe in the power of individuals and communities to shape their futures, and we recognize that there’s no one right answer to the education challenges communities face. We are embracing education as the engine of opportunity and support a variety of initiatives to give everyone a right to a quality education. We are focused on the following Sustainable Development Goals for Education for All:')}
              </p>
              <p>
                {
                  locale === 'en' ? <>
                    <b>Goal 1:</b> Expand early childhood care and education <br/>
                    <b>Goal 2:</b> Provide free and compulsory primary education for all <br/>
                    <b>Goal 3:</b>Promote learning and life skills for young people and adults <br/>
                    <b>Goal 6:</b> Improve the quality of education
                  </> : <>
                    <b>Mục tiêu 1:</b> Mở rộng chăm sóc và giáo dục mầm non <br/>
                    <b>Mục tiêu 2:</b> Cung cấp giáo dục tiểu học bắt buộc và miễn phí cho tất cả mọi người <br/>
                    <b>Mục tiêu 3:</b>Thúc đẩy học tập và kỹ năng sống cho thanh thiếu niên và người lớn <br/>
                    <b>Mục tiêu 6:</b> Nâng cao chất lượng giáo dục
                  </>
                }
              </p>

            </div>
          </div>
          {/* Image Section - Right */}
          <div className='flex-1 md:flex-[1] w-full md:w-auto hidden md:block'>
            <img
              src={imgs['image 2216 (2).png']}
              alt="Who We Are"
              className='w-full h-auto object-cover'
            />
          </div>
        </div>
      </div>

      {/*Scholarships*/}
      <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
        <h2 className='text-lg md:text-3xl font-bold text-center mb-6 md:mb-12 text-black'>
          {fm('SCHOLARSHIPS')}
        </h2>

        {/* NP Family Changemaker Scholarship - Desktop */}
        <div className='hidden md:flex md:flex-row gap-8 md:gap-12 mb-8 md:mb-16 bg-[#F2F2F7] rounded-2xl overflow-hidden'>
          {/* Left Image */}
          <div className='flex-shrink-0 w-[300px] bg-[#00186D] flex items-center justify-center p-8'>
            <img
              src={imgs['image 2217 (1).png']}
              alt="Fulbright University Vietnam"
              className='w-full h-auto object-contain'
            />
          </div>

          {/* Right Content */}
          <div className='flex-1 p-6 md:p-8 flex flex-col justify-between'>
            <div>
              <h3 className='text-xl md:text-2xl font-bold mb-4 text-black uppercase'>
                {fm('NP FAMILY CHANGEMAKER SCHOLARSHIP, VIETNAM')}
              </h3>
              <div className='space-y-4 text-base md:text-lg leading-relaxed text-black'>
                <p>
                  {fm('Fulbright University Vietnam is the country\'s first not-for-profit, independent university offering a liberal arts undergraduate program. It strives to close the gap between higher education and Vietnam\'s greatest needs by building the next generation of Vietnamese leaders equipped with the skills to tackle global challenges.')}
                </p>
                <p>
                  {locale === 'en' ? (
                    <>
                      With alignment in core values and in the mission to grow Vietnamese talents to become future changemakers, Fulbright University, <b>VietSeeds Foundation</b> and our family created the Nguyễn-Phương Family Scholarship ("NP Family Scholarship").
                    </>
                  ) : (
                    <>
                      Với sự đồng điệu về giá trị cốt lõi và chung sứ mệnh nuôi dưỡng nhân tài Việt Nam trở thành những nhà kiến tạo thay đổi trong tương lai, Đại học Fulbright Việt Nam, <b>Quỹ VietSeeds</b> và Gia đình Nguyễn-Phương đã cùng nhau sáng lập Học bổng Gia đình Nguyễn-Phương (Nguyen-Phuong Family Scholarship – NP Family Scholarship).
                    </>
                  )}
                </p>
                <p>
                  {locale === 'en' ? (
                    <>
                      The spirit of the scholarship is to help form generations of Vietnamese leaders/changemakers (in all fields of society) for a more humane, kinder world – a world built on solidarity instead of competition; a world focusing on broad human development and social sustainability instead of just economic and material development; a world based on the principle that the meaning of human life is in the <b>Being, and not in the Having.</b>
                    </>
                  ) : (
                    <>
                      Tinh thần của học bổng là góp phần hình thành nên các thế hệ lãnh đạo và nhà kiến tạo thay đổi Việt Nam (trong mọi lĩnh vực của xã hội) cho một thế giới nhân văn và tử tế hơn — một thế giới được xây dựng trên tinh thần đoàn kết thay vì cạnh tranh; một thế giới coi trọng sự phát triển toàn diện của con người và tính bền vững xã hội, thay vì chỉ tập trung vào tăng trưởng kinh tế và giá trị vật chất; một thế giới dựa trên nguyên lý rằng ý nghĩa của đời sống con người nằm ở sự hiện hữu (<b>Being</b>) chứ không phải sự sở hữu (<b>Having</b>).
                    </>
                  )}
                </p>
              </div>
            </div>
            <div className='mt-6 text-right'>
              <button
                onClick={() => window.open('https://fulbright.edu.vn/nguyen-phuong-family-scholarship/', '_blank')}
                className='uppercase bg-[#354402] text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#2a3501] transition-colors'
              >
                {fm('Learn more')}
              </button>
            </div>
          </div>
        </div>

        {/* NP Family Changemaker Scholarship - Mobile */}
        <div className='block md:hidden mb-3'>
          <div
            onClick={() => window.open('https://fulbright.edu.vn/nguyen-phuong-family-scholarship/', '_blank')}
            className='bg-[#F2F2F7] rounded-2xl overflow-hidden cursor-pointer'
          >
            {/* Title Section with Colored Block */}
            <div className='flex items-stretch'>
              {/* Colored Block - Leftmost with rounded corners */}
              <div
                className='w-[50px] flex-shrink-0 bg-[#D2E3AA]'
                style={{
                  borderTopLeftRadius: '12px',
                  borderBottomLeftRadius: '0',
                  borderTopRightRadius: '0',
                  borderBottomRightRadius: '0'
                }}
              ></div>

              {/* Title and Arrow */}
              <div>
                <div className='flex-1 px-4 py-4 flex items-center justify-between'>
                  <h3 className='text-sm font-bold text-black uppercase leading-tight mb-0'>
                    {fm('NP FAMILY CHANGEMAKER SCHOLARSHIP, VIETNAM')}
                  </h3>
                  <img
                    src={imgs['arrow-down-right-svgrepo-com 14.svg']}
                    alt="Learn more"
                    className='w-5 h-5 flex-shrink-0'
                  />
                </div>
                {/* Description Content - Below Title */}
                <div className='px-4 pb-4'>
                  <div className='space-y-3 text-sm leading-relaxed text-black'>
                    <p>
                      {fm('Fulbright University Vietnam is the country\'s first not-for-profit, independent university offering a liberal arts undergraduate program. It strives to close the gap between higher education and Vietnam\'s greatest needs by building the next generation of Vietnamese leaders equipped with the skills to tackle global challenges.')}
                    </p>
                    <p>
                      {locale === 'en' ? (
                        <>
                          With alignment in core values and in the mission to grow Vietnamese talents to become future
                          changemakers, Fulbright University, <b>VietSeeds Foundation</b> and our family created the
                          Nguyễn-Phương Family Scholarship ("NP Family Scholarship").
                        </>
                      ) : (
                        <>
                          Với sự đồng điệu về giá trị cốt lõi và chung sứ mệnh nuôi dưỡng nhân tài Việt Nam trở thành
                          những nhà kiến tạo thay đổi trong tương lai, Đại học Fulbright Việt Nam, <b>Quỹ
                          VietSeeds</b> và Gia đình Nguyễn-Phương đã cùng nhau sáng lập Học bổng Gia đình Nguyễn-Phương
                          (Nguyen-Phuong Family Scholarship – NP Family Scholarship).
                        </>
                      )}
                    </p>
                    <p>
                      {locale === 'en' ? (
                        <>
                          The spirit of the scholarship is to help form generations of Vietnamese leaders/changemakers
                          (in all fields of society) for a more humane, kinder world – a world built on solidarity
                          instead of competition; a world focusing on broad human development and social sustainability
                          instead of just economic and material development; a world based on the principle that the
                          meaning of human life is in the <b>Being, and not in the Having.</b>
                        </>
                      ) : (
                        <>
                          Tinh thần của học bổng là góp phần hình thành nên các thế hệ lãnh đạo và nhà kiến tạo thay đổi
                          Việt Nam (trong mọi lĩnh vực của xã hội) cho một thế giới nhân văn và tử tế hơn — một thế giới
                          được xây dựng trên tinh thần đoàn kết thay vì cạnh tranh; một thế giới coi trọng sự phát triển
                          toàn diện của con người và tính bền vững xã hội, thay vì chỉ tập trung vào tăng trưởng kinh tế
                          và giá trị vật chất; một thế giới dựa trên nguyên lý rằng ý nghĩa của đời sống con người nằm ở
                          sự hiện hữu (<b>Being</b>) chứ không phải sự sở hữu (<b>Having</b>).
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </div>

            </div>


          </div>
        </div>

        {/* Higher Education Scholarships - Desktop */}
        <div className='hidden md:flex md:flex-row gap-8 md:gap-12 bg-[#F2F2F7] rounded-2xl overflow-hidden'>
          {/* Left Icon */}
          <div className='flex-shrink-0 w-[300px] bg-[#354402] flex items-center justify-center p-8'>
            <img
              src={imgs['graduation-mortarboard-svgrepo-com.png']}
              alt="Higher Education"
              className='w-32 h-32 object-contain'
            />
          </div>

          {/* Right Content */}
          <div className='flex-1 p-6 md:p-8'>
            <h3 className='text-xl md:text-2xl font-bold mb-4 text-black uppercase'>
              {fm('HIGHER EDUCATION SCHOLARSHIPS')}
            </h3>
            <ul className='space-y-2 text-base md:text-lg leading-relaxed text-black list-disc list-inside'>
              <li>{fm('The Nguyen Phuong Thiep Fellowship Fund at Stanford Graduate School of Business, USA')}</li>
              <li>{fm('The Nguyen-Phuong Family Endowed Scholarship at Georgetown University, USA')}</li>
              <li>{fm('The Friends of Luke Rogers International Programs Endowed Fund at Pitzer College, USA')}</li>
              <li>{fm('The Lam-Anh Jennifer Nguyen-Phuong Scholarship Fund at Scripps College, USA')}</li>
            </ul>
          </div>
        </div>

        {/* Higher Education Scholarships - Mobile */}
        <div className='block md:hidden mb-3'>
          <div className='bg-[#F2F2F7] rounded-2xl overflow-hidden'>
            {/* Title Section with Colored Block */}
            <div className='flex items-stretch'>
              {/* Colored Block - Leftmost with rounded corners */}
              <div
                className='w-[50px] flex-shrink-0 bg-[#D2E3AA]'
                style={{
                  borderTopLeftRadius: '12px',
                  borderBottomLeftRadius: '0',
                  borderTopRightRadius: '0',
                  borderBottomRightRadius: '0'
                }}
              ></div>

              {/* Title */}
              <div className='flex-1 px-4 py-4'>
                <h3 className='text-sm font-bold text-black uppercase leading-tight mb-4'>
                  {fm('HIGHER EDUCATION SCHOLARSHIPS')}
                </h3>
                {/* Description Content - Below Title */}
                <ul className='pl-0 text-sm text-black list-disc list-inside'>
                  <li>{fm('The Nguyen Phuong Thiep Fellowship Fund at Stanford Graduate School of Business, USA')}</li>
                  <li>{fm('The Nguyen-Phuong Family Endowed Scholarship at Georgetown University, USA')}</li>
                  <li>{fm('The Friends of Luke Rogers International Programs Endowed Fund at Pitzer College, USA')}</li>
                  <li>{fm('The Lam-Anh Jennifer Nguyen-Phuong Scholarship Fund at Scripps College, USA')}</li>
                </ul>
              </div>
            </div>


          </div>
        </div>
      </div>

      {/*Partnerships*/}
      <Partnerships partnerships={partnerships}/>

      {/* bottom part - Quote section */}
      <div className='relative -mb-1 md:mb-auto md:py-20 px-5 md:px-10 h-[150px] md:h-[400px] flex items-center justify-end'>
        <img
          src={imgs['Group 30091.png']}
          alt="Quote Background"
          className='absolute inset-0 w-full h-[150px] md:h-auto'
        />
        <div className='relative mt-0 z-10 max-w-[205px] md:max-w-2xl mx-auto'>
          <div className='text-xs md:text-2xl font-bold text-black leading-[1.3] md:leading-relaxed text-center'>
            {
              locale === 'en' ?
                <>
                  Education is not only the transfer of information; it is the transmission of being.
                </> :
                <>
                  Giáo dục không chỉ là việc truyền đạt thông tin; nó còn là việc truyền tải bản thể.
                </>
            }
          </div>
        </div>
      </div>

    </>
  )
}

export default EducationForAll;
